module.exports = __webpack_public_path__ + "static/media/tabcon-01.f59dceab.png";